import type { HexMapState } from '../render/renderer';

export function getDeployedUnits(state: HexMapState, settlementId: string): Record<string, number> {
    const deployed: Record<string, number> = {};
    state.scoutingMissions.forEach((mission) => {
        if (mission.fromSettlementId !== settlementId) return;
        if (mission.status === 'complete') return;
        mission.units.forEach((group) => {
            deployed[group.type] = (deployed[group.type] || 0) + group.count;
        });
    });
    state.foundingExpeditions.forEach((expedition) => {
        if (expedition.fromSettlementId !== settlementId) return;
        if (expedition.status !== 'traveling') return;
        expedition.escortUnits.forEach((group) => {
            deployed[group.type] = (deployed[group.type] || 0) + group.count;
        });
    });
    return deployed;
}
